import { NavLink, Outlet } from "react-router-dom";
import { UserRound, LayoutDashboard, Users, BarChart3, Building2, Settings } from "lucide-react";

const TABS = [
  { to: "/guests",             label: "Dashboard",  icon: LayoutDashboard, end: true, testid: "guest-tab-dashboard" },
  { to: "/guests/directory",   label: "Directory",  icon: Users,           testid: "guest-tab-directory" },
  { to: "/guests/companies",   label: "Corporate",  icon: Building2,       testid: "guest-tab-companies" },
  { to: "/guests/analytics",   label: "Analytics",  icon: BarChart3,       testid: "guest-tab-analytics" },
  { to: "/guests/settings",    label: "Settings",   icon: Settings,        testid: "guest-tab-settings" },
];

export default function GuestShell() {
  return (
    <div className="space-y-6" data-testid="guest-shell">
      <div className="flex items-baseline gap-3">
        <div className="w-11 h-11 rounded-xl bg-hocp-gold flex items-center justify-center shrink-0">
          <UserRound className="w-5 h-5 text-hocp-eerie" strokeWidth={2}/>
        </div>
        <div>
          <h1 className="font-display text-[26px] font-bold text-hocp-navy leading-none">Guest Experience OS</h1>
          <p className="text-[13px] text-slate-500 mt-1.5">
            One profile per guest · Reservations · Finance · F&amp;B · Housekeeping · Maintenance all enrich the same record.
          </p>
        </div>
      </div>
      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-medium border-b-2 whitespace-nowrap ${
                  isActive ? "border-hocp-navy text-hocp-navy" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
              <Icon className="w-4 h-4" strokeWidth={1.75}/>{t.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet/>
    </div>
  );
}
